import { type FC, type ReactNode } from 'react';

import Image from 'shared/components/Image';
import styles from './SpikedTextFrame.module.css';

interface SpikedTextFrameProps {
  children: ReactNode;
  show?: boolean;
}

const SpikedTextFrame: FC<SpikedTextFrameProps> = ({ children, show = true }) => {
  if (!show) {
    return <>{children}</>;
  }

  return (
    <>
      <span className={styles.spike}>
        <Image src={'/campaigns/icons/titleLine'} manualAffix=".svg" />
      </span>
      {children}
      <span className={`${styles.spike} ${styles.spikeBack}`}>
        <Image src={'/campaigns/icons/titleLine'} manualAffix=".svg" />
      </span>
    </>
  );
};

export default SpikedTextFrame;
